import { getBounds } from 'geolib';
import isEmpty from 'lodash.isempty';

/**
 * Pass Algolia Property Hits as MapBox markers and it returns the
 * center of bounds of all the hits for use with bounds/fitBounds in maps
 *
 * See https://www.mapbox.com/mapbox-gl-js/api/#Map#fitBounds
 * or https://github.com/alex3165/react-mapbox-gl/blob/master/docs/API.md
 *
 * @param object markers property hits from Algolia transformed to Mapbox markers
 * @returns array formatted for use with fitBounds or bounds
 */
export const getMapboxInitialBounds = markers => {
    if (isEmpty(markers)) {
        return;
    }

    const geoBounds = getBounds(markers);

    if (!geoBounds) {
        return;
    }

    const bounds = [
        [geoBounds?.minLng, geoBounds?.minLat],
        [geoBounds?.maxLng, geoBounds?.maxLat],
    ];

    return bounds;
};

/**
 * Pass Algolia Property Hits as MapBox markers and it returns the
 * center of bounds of all the hits for use with Algolia connectGeoSearch
 *
 * @see https://www.algolia.com/doc/api-reference/widgets/geo-search/react/#connector
 * @param object markers property hits from Algolia transformed to Mapbox markers
 * @returns object formatted for use Algolia connectGeoSearch
 */
export const getAlgoliaGeoInitialBounds = markers => {
    if (isEmpty(markers)) {
        return;
    }

    const geoBounds = getBounds(markers);

    if (!geoBounds) {
        return;
    }

    const bounds = {
        northEast: { lat: geoBounds?.minLat, lng: geoBounds?.minLng },
        southWest: { lat: geoBounds?.maxLat, lng: geoBounds?.maxLng },
    };

    return bounds;
};
